import { useState } from 'react';
import { downloadCsv, useIncomeStatement } from '../hooks/useReports';
import PrintButton from '../components/PrintButton';

export default function IncomeStatementPage() {
  const today = new Date();
  const yearStart = `${today.getFullYear()}-01-01`;
  const yearEnd = `${today.getFullYear()}-12-31`;

  const [dateFrom, setDateFrom] = useState(yearStart);
  const [dateTo, setDateTo] = useState(yearEnd);
  const [applied, setApplied] = useState({ dateFrom: yearStart, dateTo: yearEnd });
  const { data, isLoading, error } = useIncomeStatement(applied);

  return (
    <div>
      <div className="page-header">
        <h2>損益計算書</h2>
      </div>
      {error && <div className="error-banner">{(error as Error).message}</div>}

      <div className="card">
        <div className="toolbar">
          <label>
            期間From{' '}
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            期間To{' '}
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>
          <button className="primary" onClick={() => setApplied({ dateFrom, dateTo })}>
            表示
          </button>
          <button onClick={() => downloadCsv('/api/reports/income-statement', applied)}>CSV出力</button>
          <PrintButton />
        </div>
      </div>

      {isLoading && <div>読み込み中...</div>}

      {data && (
        <>
          <div className="card">
            <h3 style={{ margin: 0 }}>収入金額</h3>
          </div>
          <table>
            <thead>
              <tr>
                <th style={{ width: 90 }}>コード</th>
                <th>勘定科目</th>
                <th className="numeric" style={{ width: 160 }}>金額</th>
              </tr>
            </thead>
            <tbody>
              {data.revenues.map((r) => (
                <tr key={r.accountId}>
                  <td>{r.code}</td>
                  <td>{r.name}</td>
                  <td className="numeric">{r.balance.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={2} style={{ textAlign: 'right' }}>収入金額合計</th>
                <th className="numeric">{data.totalRevenue.toLocaleString()}</th>
              </tr>
            </tfoot>
          </table>

          <div className="card" style={{ marginTop: 24 }}>
            <h3 style={{ margin: 0 }}>経費</h3>
          </div>
          <table>
            <thead>
              <tr>
                <th style={{ width: 90 }}>コード</th>
                <th>勘定科目</th>
                <th className="numeric" style={{ width: 160 }}>金額</th>
              </tr>
            </thead>
            <tbody>
              {data.expenses.map((e) => (
                <tr key={e.accountId}>
                  <td>{e.code}</td>
                  <td>{e.name}</td>
                  <td className="numeric">{e.balance.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={2} style={{ textAlign: 'right' }}>経費合計</th>
                <th className="numeric">{data.totalExpense.toLocaleString()}</th>
              </tr>
            </tfoot>
          </table>

          <div className="card" style={{ marginTop: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <strong style={{ fontSize: 16 }}>差引金額（所得金額）</strong>
              <strong
                className="numeric"
                style={{
                  fontSize: 18,
                  color: data.netIncome >= 0 ? 'var(--color-success)' : 'var(--color-danger)',
                }}
              >
                {data.netIncome.toLocaleString()} 円
              </strong>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
